//其他入库

export default [
 
    {   // 节假日管理
        path: "holiday/index",
        name: "holidayIndex",
        component: () => import(/* webpackChunkName: "holiday" */ "@/views/holiday/index"),
    },
    {   //update 节假日管理
        path: "holiday/update/:type",
        name: "holidayDetail",
        component: () => import(/* webpackChunkName: "holiday" */ "@/views/misc/inbound/update"),
    },
  
  
]


